import {
  PILOTAGE_TUGS_IN_PROGRESS,
  PILOTAGE_TUGS_ERROR,
  PILOTAGE_TUGS_SUCCESS,
  PILOTAGE_TUGS_ADD_IN_PROGRESS,
  PILOTAGE_TUGS_ADD_ERROR,
  PILOTAGE_TUGS_ADD_SUCCESS,
  PILOTAGE_TUGS_REMOVE_IN_PROGRESS,
  PILOTAGE_TUGS_REMOVE_ERROR,
  PILOTAGE_TUGS_REMOVE_SUCCESS,
} from 'src/store/pilotageTugs/actions'
import { CLEAR_PILOTAGE_DATA } from 'src/store/common/actions'
import { SYNC_ENTITY_SUCCESS } from 'src/store/sync/actions'
import { SYNC_ENTITY_TYPES } from 'src/utils/constants'

const INITIAL_STATE = {
  pilotageUuid: null,
  data: null,
  list: [],
  isLoading: false,
  error: null,
}

const flattenPilotageTugs = source => {
  if (!source) {
    return []
  }
  if (Array.isArray(source)) {
    return source
  }
  if (typeof source === 'object') {
    return Object.values(source).reduce((acc, stageEntry) => {
      if (!stageEntry) {
        return acc
      }
      if (Array.isArray(stageEntry)) {
        return acc.concat(stageEntry.filter(Boolean))
      }
      if (typeof stageEntry === 'object') {
        return acc.concat(Object.values(stageEntry).filter(Boolean))
      }
      return acc
    }, [])
  }
  return []
}

function pilotageTugsReducer(state = INITIAL_STATE, action) {
  const { type, payload } = action

  switch (type) {
    case CLEAR_PILOTAGE_DATA:
      return { ...INITIAL_STATE }
    case PILOTAGE_TUGS_IN_PROGRESS:
    case PILOTAGE_TUGS_ADD_IN_PROGRESS:
    case PILOTAGE_TUGS_REMOVE_IN_PROGRESS:
      return {
        ...state,
        isLoading: true,
        error: null,
      }
    case PILOTAGE_TUGS_ERROR:
    case PILOTAGE_TUGS_ADD_ERROR:
    case PILOTAGE_TUGS_REMOVE_ERROR:
      return {
        ...state,
        error: payload,
        isLoading: false,
      }
    case PILOTAGE_TUGS_SUCCESS:
    case PILOTAGE_TUGS_ADD_SUCCESS:
    case PILOTAGE_TUGS_REMOVE_SUCCESS: {
      const list = flattenPilotageTugs(payload.data)
      const mapData = Array.isArray(payload.data)
        ? payload.data.reduce((data, pilotageTug) => {
            const stageUuid = pilotageTug.stage && pilotageTug.stage.uuid
            const lineNumber = pilotageTug.lineNumber
            if (!stageUuid || lineNumber == null) return data
            if (!data[stageUuid]) data[stageUuid] = {}
            data[stageUuid][lineNumber] = pilotageTug
            return data
          }, {})
        : payload.data

      return {
        ...state,
        data: mapData,
        list,
        isLoading: false,
        error: null,
        pilotageUuid: payload.pilotageUuid,
      }
    }
    case SYNC_ENTITY_SUCCESS: {
      const {
        type: syncType,
        entity: { pilotageUuid },
      } = payload
      const { result } = action
      return syncType !== SYNC_ENTITY_TYPES.PILOTAGE_TUGS ||
        pilotageUuid !== state.pilotageUuid
        ? state
        : {
            ...state,
            data: result.reduce(
              (data, pilotageTug) => {
                const stageUuid = pilotageTug.stage && pilotageTug.stage.uuid
                const lineNumber = pilotageTug.lineNumber
                if (!stageUuid || lineNumber == null) return data
                if (!data[stageUuid]) data[stageUuid] = {}
                data[stageUuid][lineNumber] = pilotageTug
                return data
              },
              {}
            ),
            list: flattenPilotageTugs(result),
          }
    }
    default:
      return state
  }
}

export default pilotageTugsReducer
